export class EbsRestoreDestination {
    'awsEbs';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsEbs",
            "baseName": "awsEbs",
            "type": "EbsTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EbsRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
